export default {
    orientation: String, 
    panes: Array, 

    // Events
    collapse: Function, 
    contentLoad: Function, 
    error: Function, 
    expand: Function, 
    layoutChange: Function, 
    resize: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoSplitter/SplitterProps.js